export default { 
  CertifPart: require('./CertifPart').default,
  CertifGrad: require('./CertifGrad').default,
  CertifGradScore: require('./CertifGradScore').default,
}